import "./BillingFormModal.css";

const BillingConfirmDeleteModal = ({
  isOpen,
  title,
  description,
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  isBusy = false,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="billing-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="billing-modal billing-modal--confirm"
        role="dialog"
        aria-modal="true"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="billing-modal__header">
          <div>
            <h3 className="billing-modal__title">{title}</h3>
            <p className="billing-modal__description">{description}</p>
          </div>
          <button
            type="button"
            className="billing-modal__close"
            onClick={onClose}
            aria-label="Close dialog"
          >
            ×
          </button>
        </div>

        <div className="billing-modal__footer">
          <button
            type="button"
            className="billing-modal__button billing-modal__button--secondary"
            onClick={onClose}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className="billing-modal__button billing-modal__button--danger"
            onClick={onConfirm}
            disabled={isBusy}
          >
            {isBusy ? "Deleting..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BillingConfirmDeleteModal;
